import TerraShopImage from './images/TerraShop.png';
import TerraShopMobile from './images/TerraShopMobile.png';
import MovieAppImage from './images/MovieApp.png';
import MovieAppMobile from './images/MovieAppMobile.png';
import GoogleClone from './images/google-clone.png'
import GoogleCloneMobile from './images/google-clone-phone.PNG'
import BlogsImage from './images/Blogs.png';
import BlogsMobile from './images/BlogsMobile.png'
import ChatImage from './images/chatapp1.PNG';
import ChatMobile from './images/chatapp2.PNG'
import HTML from './images/HTML.png';
import CSS from './images/CSS.png';
import JS from './images/JS.png';
import TS from './images/TS.png';
import REACT from './images/REACT.png';
import REDUX from './images/REDUX.png'
import NODEJS from './images/NODEJS.png';
import MYSQL from './images/MYSQL.png';
import Spotify from './images/Spotify.png';
import SpotifyMobile from './images/SpotifyMobile.PNG';
import Wordle from './images/wordle.png';
import WordleMobile from './images/wordle-mobile.png';


export const TerraShop = {
    name: 'Terra Shop',
    liveLink: 'https://kacper-kubic-terra-shop.vercel.app',
    repoLink: 'https://github.com/KacperKubic/React-Website',
    description: 'Fully resposive React and CSS website. It uses a lot of core concepts of React such us hooks and Context API. It also make use of react framer motion liblary for smooth transitions and animations',
    image: TerraShopImage,
    imageMobile: TerraShopMobile,
}

export const MovieApp = {
    name: 'Movie App',
    liveLink: 'https://kacper-kubic-movie-app.vercel.app',
    repoLink: 'https://github.com/KacperKubic/React-Movie-App',
    description: 'Website that uses TMDB API to display different movies and their details. It also allows the user to search for a specific movie and add movies to three different lists that are stored in local storage.',
    image: MovieAppImage,
    imageMobile: MovieAppMobile,
}

export const Blogs = {
    name: 'Blogs App',
    liveLink: 'https://drive.google.com/drive/u/1/folders/17uX4gM9hvbgSXTgHD2_Mt70CKgbgiPrT',
    repoLink: 'https://github.com/KacperKubic/Blogs',
    description: 'Fullstack website made with Node.js and React. It allows the user to add and read blogs. It uses MySQL to store all the data.',
    image: BlogsImage,
    imageMobile: BlogsMobile,
}

export const ChatApp = {
    name: 'Chat App',
    liveLink: 'https://drive.google.com/drive/u/1/folders/1oC9IauTacMYF1wY1GkzLowAf5t0Ryzlx',
    repoLink: 'https://github.com/KacperKubic/chat-app',
    description: 'Fullstack chat app made with Node.js, React and Socket.io. It allows two users to join a chat room with same ID and text eachother.',
    image: ChatImage,
    imageMobile: ChatMobile,
}

export const GoogleSearchClone = {
    name: 'Google Clone',
    liveLink: 'https://kacper-kubic-google-clone.vercel.app',
    repoLink: 'https://github.com/KacperKubic/google-search-clone',
    description: 'Google Search Clone. It uses Google Custom Search Engine API that returns different websites links based on search term.',
    image: GoogleClone,
    imageMobile: GoogleCloneMobile,
}

export const SpotifyClone = {
    name: 'Spotify Clone',
    liveLink: 'https://drive.google.com/drive/u/1/folders/1OXy9paoKfMqZQqOYnG8RCC9j5x0rse9G',
    repoLink: 'https://github.com/KacperKubic/spotify-clone',
    description: 'Spotify Clone made with React and CSS. It uses official Spotify Web API. Unfortunately due to free Spotify API limitation I have to add users who can use it manually on Spotify API dashbord that is why I cannot create live version of this project',
    image: Spotify,
    imageMobile: SpotifyMobile,
}

export const WordleClone = {
    name: 'Wordle Clone',
    liveLink: 'https://kacper-kubic-wordle.vercel.app',
    repoLink: 'https://github.com/KacperKubic/wordle-clone',
    description: 'Clone of the popular Wordle game made with React and CSS.',
    image: Wordle,
    imageMobile: WordleMobile,
}

export const TechnologiesList = [
    {
        name: 'HTML',
        image: HTML,
    },
    {
        name: 'CSS',
        image: CSS,
    },
    {
        name: 'JavaScript',
        image: JS,
    },
    {
        name: 'TypeScript',
        image: TS,
    },
    {
        name: 'React',
        image: REACT,
    },
    {
        name: 'Redux',
        image: REDUX,
    },
    {
        name: 'NodeJS',
        image: NODEJS,
    },
    {
        name: 'MySQL',
        image: MYSQL,
    },
]
